import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('prescriptionImportPage');

    return {
        CONTINUE_CTA: t('continueCta'),
        DROP_ZONE_CTA: t('dropZoneCta'),
        DROP_ZONE_CTA_PROCESSING: t('dropZoneCtaProcessing'),
        DROP_ZONE_FORMATS: t('dropZoneFormats'),
        ERROR_APPLICATION_FAILED: t('errorApplicationFailed'),
        ERROR_BOUNDARY_FAILED: t('errorBoundaryFailed'),
        ERROR_CRS: (detected: string) => t('errorCrs', { detected }),
        ERROR_INVALID_POLYGONS: (count: number) => t('errorInvalidPolygons', { count }),
        ERROR_PARSE_FAILED: (message: string) => t('errorParseFailed', { message }),
        ERROR_PRESCRIPTION_FAILED: t('errorPrescriptionFailed'),
        GAP_POLICY_BASE_RATE: t('gapPolicyBaseRate'),
        GAP_POLICY_MASK: t('gapPolicyMask'),
        PAGE_CANCEL: t('pageCancel'),
        PAGE_EYEBROW: t('pageEyebrow'),
        PAGE_SUBTITLE: t('pageSubtitle'),
        PAGE_SUPPORT: t('pageSupport'),
        PAGE_TITLE: t('pageTitle'),
        PAGE_TOP_BAR_TITLE: t('pageTopBarTitle'),
        PREVIEW_APPROX_AREA: t('previewApproxArea'),
        PREVIEW_AREA_VALUE: (hectares: string) => t('previewAreaValue', { hectares }),
        PREVIEW_CRS: t('previewCrs'),
        PREVIEW_CRS_VALUE: (check: string) => t('previewCrsValue', { check }),
        PREVIEW_FILE: t('previewFile'),
        PREVIEW_RATE_COLUMN: t('previewRateColumn'),
        PREVIEW_RATE_RANGE: t('previewRateRange'),
        PREVIEW_RATE_SINGLE: (rate: string, unit: string) => t('previewRateSingle', { rate, unit }),
        PREVIEW_RATE_SPAN: (min: string, max: string, unit: string) =>
            t('previewRateSpan', { max, min, unit }),
        PREVIEW_ZONES: t('previewZones'),
        RAIL_BOUNDARY_EMPTY_BODY: t('railBoundaryEmptyBody'),
        RAIL_BOUNDARY_READY_BOUNDING_BOX_LABEL: t('railBoundaryReadyBoundingBoxLabel'),
        RAIL_BOUNDARY_READY_BOUNDING_BOX_VALUE: (width: string, height: string) =>
            t('railBoundaryReadyBoundingBoxValue', { height, width }),
        RAIL_BOUNDARY_READY_CENTROID_LABEL: t('railBoundaryReadyCentroidLabel'),
        RAIL_BOUNDARY_READY_CENTROID_VALUE: (lat: string, lng: string) =>
            t('railBoundaryReadyCentroidValue', { lat, lng }),
        RAIL_BOUNDARY_READY_ZONES_LABEL: t('railBoundaryReadyZonesLabel'),
        RAIL_BOUNDARY_READY_ZONES_VALUE: (count: number) =>
            t('railBoundaryReadyZonesValue', { count }),
        RAIL_BOUNDARY_TITLE: t('railBoundaryTitle'),
        RAIL_NEXT_BODY: t('railNextBody'),
        RAIL_NEXT_READY_BODY: t('railNextReadyBody'),
        RAIL_NEXT_READY_TITLE: t('railNextReadyTitle'),
        RAIL_NEXT_TITLE: t('railNextTitle'),
        RATE_COLUMN_CONFIRM: t('rateColumnConfirm'),
        RATE_COLUMN_HINT: t('rateColumnHint'),
        RATE_COLUMN_LABEL: t('rateColumnLabel'),
        REPLACE_FILE_CTA: t('replaceFileCta'),
        SECTION_1_EMPTY_HINT: t('section1EmptyHint'),
        SECTION_1_EMPTY_TITLE: t('section1EmptyTitle'),
        SECTION_1_FILLED_TITLE: t('section1FilledTitle'),
        SECTION_2_EYEBROW: t('section2Eyebrow'),
        SECTION_2_HINT: t('section2Hint'),
        SECTION_2_TITLE: t('section2Title'),
        SECTION_EYEBROW_STEP_1: t('sectionEyebrowStep1'),
        SUBMITTING_CTA: t('submittingCta'),
        SUPPORT_ORG_PLACEHOLDER: t('supportOrgPlaceholder'),
        WARNING_DISMISS: t('warningDismiss'),
        WARNING_TITLE: t('warningTitle')
    };
};

export default useTranslation;
